export enum EROLES{
    STANDARD=3,
    AUTHOR=2,
    ADMIN=1,
}